//
//
//
//
//
//
//
//
//
//
//

import JobQueryList from "@/components/JobQuery/List";
export default {
  name: "JobQuery",
  data() {
    return {};
  },
  components: { JobQueryList },
  filters: {},
  watch: {},
  mounted() {},
  created() {},
  methods: {},
};
